import type { EducationLevel } from 'utils/constants/general/educationLevels';
import { EDUCATION_LEVELS } from 'utils/constants/general/educationLevels';
import type { ProfessionalLevel } from 'utils/constants/general/professionalLevels';
import { PROFESSIONAL_LEVELS } from 'utils/constants/general/professionalLevels';

export function getProfessionalLevelName(levelId: ProfessionalLevel) {
  return PROFESSIONAL_LEVELS[levelId];
}

export function getEducationLevelName(levelId: EducationLevel) {
  return EDUCATION_LEVELS[levelId];
}
